var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import React, { Component } from 'react';
import ClinicalNotesCardAPI from './clinical-notes-card-api';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as PendingIcon } from '../../assets/images/global/time.svg';
import { ReactComponent as ReleasedIcon } from '../../assets/images/global/check.svg';
import { ReactComponent as StarIcon } from '../../assets/images/global/star.svg';
import clinicalNotesImage from '../../assets/images/global/clinical-notes-40x40.svg';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import './clinical-notes-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { DateFormatterUtil } from '../../utils';
let ClinicalNoteCard = class ClinicalNoteCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { cdEvolucao, professionalName, ieStatus, nrAtendimento, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        cdEvolucao,
                        ieStatus,
                        nrAtendimento,
                        professionalName,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIndicatorColorStatus() {
        const { ieStatus } = this.props;
        if (ieStatus && ieStatus.toUpperCase() === 'A') {
            return React.createElement("div", { className: 'c-clinical-notes-card__indicator-color-green' });
        }
        return React.createElement("div", { className: 'c-clinical-notes-card__indicator-color-orange' });
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-clinical-notes-card__indicator' }, this.renderIndicatorColorStatus()));
    }
    renderAvatar() {
        const { dtEvolucao, professionalName, dsTipoNotaClinica } = this.props;
        const dtEvolucaoFmt = DateFormatterUtil.short(String(dtEvolucao));
        return (React.createElement("div", { className: 'c-clinical-notes-card__cn-avatar' },
            this.renderStatus(),
            React.createElement(Avatar, { image: clinicalNotesImage, title: dtEvolucaoFmt, subtitle: professionalName, description: dsTipoNotaClinica })));
    }
    renderStatus() {
        return (React.createElement("div", { className: 'c-clinical-notes-card__status' }, this.getStatusIcon()));
    }
    renderFields() {
        const { dtEvolucao, professionalName, dsTipoNotaClinica } = this.props;
        const dtEvolucaoFmt = ModelService.format('date', dtEvolucao, { type: 'timestamp' });
        return (React.createElement("div", { className: 'c-clinical-notes-card__fields' },
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("a", { className: 'c-clinical-notes-card__date' }, dtEvolucaoFmt)),
                React.createElement("div", null,
                    React.createElement("a", { className: 'c-clinical-notes-card__professional' }, professionalName)),
                React.createElement("div", null,
                    React.createElement("a", { className: 'c-clinical-notes-card__professional' }, dsTipoNotaClinica)))));
    }
    getStatusIcon() {
        const { ieStatus } = this.props;
        if (ieStatus && ieStatus.toUpperCase() === 'A') {
            return React.createElement(ReleasedIcon, { className: 'c-clinical-notes-card__color-green' });
        }
        return React.createElement(PendingIcon, { className: 'c-clinical-notes-card__color-orange' });
    }
    renderTranscriptionIcon() {
        const { ieEvolucaoClinica } = this.props;
        const transcriptionType = 'TR';
        if (ieEvolucaoClinica === transcriptionType) {
            return React.createElement("div", { className: 'c-clinical-notes-card__star-wrapper' },
                React.createElement(StarIcon, null));
        }
        return React.createElement(React.Fragment, null);
    }
    render() {
        const { nrAtendimento } = this.props;
        const legends = [
            {
                color: 'signal-green-60',
                icon: React.createElement(ReleasedIcon, null),
                label: MessageService.translate('text.finished'),
                value: MessageService.translate('text.finished')
            },
            {
                color: 'signal-orange-45',
                icon: React.createElement(PendingIcon, null),
                label: MessageService.translate('tws.label-pending'),
                value: MessageService.translate('tws.label-pending')
            },
            {
                color: 'signal-purple-45',
                icon: React.createElement(StarIcon, null),
                label: MessageService.translate('text.generated-by-ai'),
                value: MessageService.translate('text.generated-by-ai')
            },
        ];
        return (React.createElement(Card, { className: 'c-clinical-notes-card', selectionType: SelectionType.SINGLE, superscription: legends, uuid: generateUUID(), width: 12, key: nrAtendimento },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-clinical-notes-card__cn-wrapper', onClick: () => this.onClick() }, this.renderAvatar()),
            this.renderTranscriptionIcon()));
    }
};
ClinicalNoteCard = __decorate([
    AwesomeComponent({ api: ClinicalNotesCardAPI, type: ComponentType.DATA_DISPLAY })
], ClinicalNoteCard);
export default ClinicalNoteCard;
//# sourceMappingURL=clinical-notes-card.js.map